module.exports = {
  "FoodB_2_Created_successfully_IqRa": "¡Creada correctamente!",
  "FoodB_up250108_muEZ_uUVF": "Copiar",
  "soda-d-i18n---下载": "Descargar",
  "FoodB_statistics_Refresh_qDDP": "Actualizar",
  "FoodC_sales_Not_set_AJmE": "Más tarde",
  "FoodB_I_Exit_sfrY": "Cerrar sesión",
  "soda-b-web-i18n---加载中": "Cargando...",
  "FoodD_one_Try_again_qZka": "Inténtalo de nuevo",
  "FoodC_remind_Unable_to_Wjlz": "No se puede cargar. Inténtalo de nuevo",
  "FoodB_up250108_UBUH_aRBX": "Por favor, establece una cuenta regresiva de la ventana emergente",
  "FoodB_modification_Modified_sTAw": "Edición completada",
  "FoodB_up250108_fBFI_ZRnR": "Cuenta regresiva emergente (Precaución: esto impide que los usuarios cierren la ventana durante hasta 10 segundos).",
  "FoodB_202502_iDjM_HZOr": "Recuerda enviar los detalles una sola vez."
}